fragment DataAccessPolicyFields on DataAccessPolicy {
  __typename
  id
  name
  description
  _rowTimestamp
  _isUpdatable
  _isDeletable
  isAdditionalTagAccessRequired
  isDocumentPoolNullDepartmentAccessible
  isDocDocumentAccess
  documentsDepartmentGroupId
  isPoDocumentAccess
  purchaseOrderDepartmentGroupId
  isTransDocumentAccess
  transactionsDepartmentGroupId
  isTaDocumentAccess
  travelAuthorizationDepartmentGroupId
  isAllBusinessUnits
  isAllWorkgroups
  isAllTagAccess
  isAllProjects
  dataAccessBusinessUnits(
    orderBy: BUSINESS_UNIT_BY_BUSINESS_UNIT_ID__NAME_ASC
  ) {
    nodes {
      id
      _rowTimestamp
      _isUpdatable
      _isDeletable
      businessUnitId
      businessUnit {
        name
      }
      isPrimary
    }
  }
}
